import * as React from 'react'
import * as ReactDOM from 'react-dom';
import { isCrossingRightSideOfViewport } from '../../../util/dom';
import { Button } from '../Button';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import { Tooltip } from '../Tooltip';

interface IPopoverProps {
  btnText?: React.ReactNode
  className?: string
  popoverClassName?: string
  noContentPadding?: boolean
  useHeaderView?: boolean
  useLinkView?: boolean
  useIcon?: boolean
  icon?: string
  iconTooltip?: string
  isActionItem?: boolean
  showRefreshSpinner?: boolean
  centerAlign?: boolean
  maxWidth?: boolean
  rightAlign?: boolean
  OnClosed?: () => void
}

interface IPopoverState {
  showPopover: boolean
  rightAlign: boolean
}

export class Popover extends React.Component<IPopoverProps, IPopoverState> {
  state: IPopoverState = {
    showPopover: false,
    rightAlign: false,
  }

  componentDidMount() {
    window.addEventListener('click', this.clickListener)
    window.addEventListener('resize', this.resizeListener)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickListener)
    window.removeEventListener('resize', this.resizeListener)
  }

  clickListener = (ev: MouseEvent) => {
    const { showPopover } = this.state
    const clickedElement = ev.target as HTMLElement
    const instanceContainer = ReactDOM.findDOMNode(this.refs.btnPopoverContainer)
    const isBtnPopoverClicked = instanceContainer === clickedElement || instanceContainer.contains(clickedElement)

    if (!isBtnPopoverClicked && showPopover) {
      this.togglePopover(false)
    }
  }

  resizeListener = () => {
    if (!this.state.showPopover) {
      return
    }

    const popoverElem = ReactDOM.findDOMNode(this)
    const popoverContentElem = (popoverElem instanceof Element) ? popoverElem.getElementsByClassName('btn-popover-content')[0] : null

    if (popoverContentElem && isCrossingRightSideOfViewport(popoverContentElem)) {
      this.setState({ rightAlign: true })
    }
  }

  togglePopover(showPopover = !this.state.showPopover) {
    if (this.props.OnClosed && !showPopover) {
      this.props.OnClosed()
    }
    this.setState({ showPopover }, () => this.resizeListener())
  }

  render() {
    const popoverContainerClasses = ['btn-popover-container']
    //Add blacklight for usage of Bootstrap rows/columns
    const popoverContentClasses = ['btn-popover-content', 'blacklight']
    const { showPopover } = this.state
    const { popoverClassName } = this.props

    if (showPopover) {
      popoverContainerClasses.push('show')
    }

    if (this.props.className) {
      popoverContainerClasses.push(this.props.className)
    }

    if (this.props.noContentPadding) {
      popoverContentClasses.push('btn-popover-content-no-pad')
    }

    if (this.state.rightAlign || this.props.rightAlign) {
      popoverContentClasses.push('btn-popover-content-right-align')
    }

    if (this.props.centerAlign) {
      popoverContentClasses.push('btn-popover-content-center-align')
    }

    if (this.props.maxWidth) {
      popoverContentClasses.push('btn-popover-content-max-width');
    }

    if (popoverClassName) {
      popoverContentClasses.push(popoverClassName);
    }

    return (
      <span className={popoverContainerClasses.join(' ')} ref="btnPopoverContainer">
        {this.props.useHeaderView ?
          <h5 className="dashboardTitle" style={{ padding: 15 }}>
            <a href="javascript:void(0)" onClick={() => this.togglePopover()}>
              {this.props.btnText}
            </a>
          </h5>
          :
          this.props.useLinkView ?
            <a href="javascript:void(0)" onClick={() => this.togglePopover()}>
              {this.props.btnText}
            </a>
            :
            this.props.useIcon ?
              <a className="btn btn-link-hc btn-sm" onClick={() => this.togglePopover()}>
                <Tooltip text={this.props.iconTooltip}>
                  <FontAwesomeIcon icon={this.props.icon} color="orange" muted={!this.props.isActionItem} />
                </Tooltip>
              </a>
              :
              <Button className="btn-popover" onClick={() => this.togglePopover()} showRefreshSpinner={this.props.showRefreshSpinner}>
                {this.props.btnText}
              </Button>
        }
        <section className={popoverContentClasses.join(' ')}>
          {this.props.children}
        </section>
      </span >
    )
  }
}
